<template>
  <!-- <div class="w-100 h-100 p-0 m-0 mx-auto">
        <Navbar />
        <router-view style="margin-top:60px"></router-view>
        <Footer />
  </div>-->

  <!-- <div class="vw-100 min-vw-100 vh-100 min-vh-100 p-0 m-0"> --> <!-- This was causing a horiz scroll bar -->
  <!-- <div flex-wrapper style="min-height: 100vh;"> -->
    <div class="flex-wrapper">
    <notifications position="bottom left" />

    <LoginDialog />
    <LoadingDialog />
    <MessageDialog />

    <VTNavbar />
    <slot />
    <!-- <Footer /> -->
  </div>
</template>

<script>
/**
 * Represents the base template for a given view.
 * Sets itself as the base component used in App.vue 'getBaseComponent'.
 * Use this template for Frontend (i.e. views that don't require login) views.
 * NOTE: This view structucture can be replicated however many times to create different base templates (see DashboardBaseTemplate.vue).
 *
 * Includes the Alert component to set alerts at the desired spot.
 *
 * Includes BaseDialogMixin that adds the dialog functions to this view and children (inherited) views.
 * Includes BaseAlertMixin that adds the alert functions to this view and children (inherited) views.
 */

import VTNavbar from "@/components/frontend/VTNavbar.vue";
// import Footer from "@/components/frontend/Footer.vue";

import BaseDialogMixin from "@/components/mixins/BaseDialogMixin.vue";
import BaseAlertMixin from "@/components/mixins/BaseAlertMixin.vue";

import LoginDialog from "@/components/dialogs/LoginDialog.vue";
import MessageDialog from "@/components/dialogs/MessageDialog.vue";
import LoadingDialog from "@/components/dialogs/LoadingDialog.vue";

import store from "@/store/store";

import { mapActions } from "vuex";

export default {
  mixins: [BaseDialogMixin, BaseAlertMixin],
  components: {
    VTNavbar,
    // Footer,
    LoginDialog,
    MessageDialog,
    LoadingDialog
  },
  beforeRouteEnter(to, from, next) {
    // this.setBaseComponent('BaseTemplate.vue');
    store.dispatch("setBaseComponent", "VTBaseTemplate");
    next();
  },
  beforeRouteUpdate(to, from, next) {
    this.setBaseComponent("VTBaseTemplate");
    next();
  },
  created: function() {
    this.setBaseComponent("VTBaseTemplate");
  },
  computed: {
    userOnMobile : function() {
      function detectMob() {
        const toMatch = [
            /Android/i,
            /webOS/i,
            /iPhone/i,
            /iPad/i,
            /iPod/i,
            /BlackBerry/i,
            /Windows Phone/i
        ];

        return toMatch.some((toMatchItem) => {
            return navigator.userAgent.match(toMatchItem);
        });
      }

      return detectMob();
    },
  },
  methods: {
    ...mapActions(["setBaseComponent"])
  }
};
</script>

<style scoped>
:root {
    --vt_lightcol: #fffba7;
    --vt_darkcol: #FFE47A;
    --vt_vdarkcol: #dcc26d;
    --vt_offwhite: #DFF2D8;
    --vt_grey: #B4B8AB;
    --vt_offblack: #153243;

    --vd_lightcol: #b0e7ff;
    --vd_darkcol: #96c6dc;
    --vd_offwhite: #DFF2D8;
    --vd_grey: #605C4E;
    --vd_offblack: #363020;
}

body {
    background-color: #f7f7f7 !important;
}

.vd-off-white-bg { 
    background-color: #f7f7f7 !important;
}


h1 {
    /* color: var(--vd_offblack); */
    color: black;
}

h2 {
    /* color: var(--vd_offblack); */
    color: black;
}

p.outset {
    border-style: groove;
    color: black;
}

p {

    font-size: large;
    /* color: var(--vd_offblack); */
    color: black;
}

hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #ccc;
    margin: 1em 0;
    padding: 0;
}

a {
    color: vd_offblack;
}

a:hover {
    color: cornflowerblue;
    text-decoration: none;
}

/* img {
    size: auto;
    opacity: .025;
    width: 100%;
    height: 10%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: auto;
    margin-top: 70px;

    filter: alpha(opacity=50);
} */

/* Container holding the image and the text */
.container {
    position: relative;
    text-align: center;
    color: white;
}

/* Bottom left text */
.bottom-left {
    position: absolute;
    bottom: 8px;
    left: 16px;
}

/* Top left text */
.top-left {
    position: absolute;
    top: 8px;
    /* top: 70px; */
    left: 16px;
}

.navbar-light-background {
    background: linear-gradient(70deg, #FFE47A,  #fffba7) !important;
}
</style>